import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {colores, globales,funciones}                                          from '../global';
import BarraBotones                                                 from './Barra_menu';
import Request                                                      from 'superagent';
import Dialog                                                       from '@material-ui/core/Dialog';
import DialogContent                                                from '@material-ui/core/DialogContent';
import DialogTitle                                                  from '@material-ui/core/DialogTitle';
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import {  CardMedia }                     from '@material-ui/core';
import AuthService                                                  from '../AuthService';

var ip=globales.ip
var border_dialog=globales.border_dialog
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);


/*                           CLASES DE ESTILO                       */

var styles = theme =>({
  media_imagen: {
    objectFit: 'cover',
    maxHeight: '490px'
  },
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0,
        width: movil_pequeño?'100%':'auto'
    },
    backdrop: {
      zIndex: 900000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
    })

/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Mensajes extends React.Component {

      constructor(props) {
        super(props);
        this.Auth = new AuthService();
        this.pagina=      props.pagina==='Principal'?localStorage.getItem('Actual')===null?props.pagina:'':props.pagina//props.pagina
        this.plataforma=  props.plataforma===undefined?null:props.plataforma;
        this.usuario =    props.usuario===undefined?null:props.usuario;

        this.state = {
            openBackDrop:      false, 
            mensajes: [],
            open_mensaje: false,
            mensaje_contenido: '',
            titulo_mensaje: 'Información',
            mostrado: 0,
            max_width: 'xs',
            align_mensaje: 'center',
            card_media: false,
            url: '',
            mostrar_titulo: true
        }


    }; //FIN CONSTRUCTORS

control_mesajes=(mostrado)=>{
  this.setState({mostrado: mostrado})
  if(this.state.mensajes.length>0)
  if(localStorage.getItem('Tabs_user')===null)
    this.setState({refresh_alcerrar: this.state.mensajes[mostrado].REFRESH_ALCERRAR,mostrar_titulo: this.state.mensajes[mostrado].MOSTRAR_TITULO,card_media: this.state.mensajes[mostrado].IMAGEN, url: this.state.mensajes[mostrado].URL,mensaje_contenido: this.state.mensajes[mostrado].MENSAJE,titulo_mensaje:  this.state.mensajes[mostrado].TITULO ,max_width: this.state.mensajes[mostrado].MAX_WIDTH,align_mensaje: this.state.mensajes[mostrado].ALIGN_MENSAJE,open_mensaje: true   }); 
  else{
      var json=JSON.parse(localStorage.getItem('Tabs_user')).filter(busqueda2 =>busqueda2.usuario.match(this.usuario))
      if(json.length>0){
      if(json[0].tabs.length>0 &&  this.state.mensajes[mostrado].MOSTRAR_ENTRE_PAGINA)
      this.setState({refresh_alcerrar: this.state.mensajes[mostrado].REFRESH_ALCERRAR,mostrar_titulo: this.state.mensajes[mostrado].MOSTRAR_TITULO,card_media: this.state.mensajes[mostrado].IMAGEN, url: this.state.mensajes[mostrado].URL,mensaje_contenido: this.state.mensajes[mostrado].MENSAJE,titulo_mensaje:  this.state.mensajes[mostrado].TITULO ,max_width: this.state.mensajes[mostrado].MAX_WIDTH,align_mensaje: this.state.mensajes[mostrado].ALIGN_MENSAJE,open_mensaje: true   }); 
      else if(json[0].tabs.length===0)
      this.setState({refresh_alcerrar: this.state.mensajes[mostrado].REFRESH_ALCERRAR,mostrar_titulo: this.state.mensajes[mostrado].MOSTRAR_TITULO,card_media: this.state.mensajes[mostrado].IMAGEN, url: this.state.mensajes[mostrado].URL,mensaje_contenido: this.state.mensajes[mostrado].MENSAJE,titulo_mensaje:  this.state.mensajes[mostrado].TITULO ,max_width: this.state.mensajes[mostrado].MAX_WIDTH,align_mensaje: this.state.mensajes[mostrado].ALIGN_MENSAJE,open_mensaje: true   }); 
      else{
        if(this.state.mensajes[mostrado+1]!==undefined && (mostrado+1)<=this.state.mensajes.length){
          this.control_mesajes(mostrado+1)
        }
      }
      }else
      this.setState({refresh_alcerrar: this.state.mensajes[mostrado].REFRESH_ALCERRAR,mostrar_titulo: this.state.mensajes[mostrado].MOSTRAR_TITULO,card_media: this.state.mensajes[mostrado].IMAGEN, url: this.state.mensajes[mostrado].URL,mensaje_contenido: this.state.mensajes[mostrado].MENSAJE,titulo_mensaje:  this.state.mensajes[mostrado].TITULO ,max_width: this.state.mensajes[mostrado].MAX_WIDTH,align_mensaje: this.state.mensajes[mostrado].ALIGN_MENSAJE,open_mensaje: true   }); 
  }
}

componentDidMount()
{

        let _this = this;
          try{
            Request.post(`${ip}/obtener_mensajes`)
            .set('Content-Type', 'application/json')
            .send({PAGINA:_this.pagina,ID_PLATAFORMA:_this.plataforma,USUARIO:_this.usuario})
            .retry(0)
            .timeout({ response: 30000, deadline: 30000, }) 
            .end((err, res) => {
             
              if (err) {     
                return;  
              }
    
              if(res!==undefined){
              const tmp = JSON.parse(res.text);
                if(tmp.length>0){
                  _this.setState({ mensajes: tmp,openBackDrop: false },()=>{
                    this.control_mesajes(0)
                  })
                }
                else
                {
                    _this.setState({mensajes: [],openBackDrop: false })
                }
              }  
              else{
                _this.setState({mensajes: [],openBackDrop: false })
              }
            })
          }
          catch(ex){
            funciones.showToast('e', 'Problemas de conexión')
          }
}

cerrarmodal_mensaje =()=> event =>{
  this.setState({open_mensaje: false},()=>{
    if(this.state.refresh_alcerrar)
    window.location.reload();
    if(this.state.mensajes[this.state.mostrado+1]!==undefined){
      this.control_mesajes(this.state.mostrado+1)
    }
  })
}

/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    const botones = [
        {icono: 'Close', nombre: 'Cerrar',onclick: this.cerrarmodal_mensaje()
        , display:'auto', color: 'red'},
    ]
  

    return (    
    <React.Fragment>
            <Backdrop className={classes.backdrop}  open={this.state.openBackDrop}>
            <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog open={this.state.open_mensaje} fullWidth={true} maxWidth={this.state.max_width}
             classes = {{ paper: classes.Dialog}}
            >
            {this.state.mostrar_titulo?
            <DialogTitle style={{margin:0,borderTopLeftRadius:border_dialog,borderTopRightRadius:border_dialog,textAlign:'center', color: 'white',background: colores.azul,padding:2}}>
                {this.state.titulo_mensaje}
            </DialogTitle>:null
            }
            <DialogContent  style={{padding: 5}}>
            {this.state.card_media?
              <CardMedia component='img' className={classes.media_imagen} src={this.state.url}></CardMedia>:null}
              <div style={{textAlign: this.state.align_mensaje,margin:!this.state.card_media?5:0}} dangerouslySetInnerHTML={{__html:this.state.mensaje_contenido}} />
            </DialogContent>
            <BarraBotones align='center' botones={botones} l={this.l} e={this.e} i={this.i}/>
          </Dialog>
    </React.Fragment>
); /// finaliza return
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    